export default __webpack_public_path__ + "static/media/hindi.70034a82.svg";